import { useQuery } from "react-query";

import { QUERY_KEYS } from "../../../constants/queryKeys";
import { ReferralApi } from "../../../services";

export const useReferralStats = ({ uuid, ciam_token }: { uuid: string; ciam_token: string }) => {
  return useQuery(QUERY_KEYS.referralStats, () => ReferralApi.init().getReferralStats(uuid, ciam_token), {
    enabled: Boolean(uuid && ciam_token),
    placeholderData: {
      earned_points: 0,
      referees_count: 0,
      completed_first_order_count: 0,
    },
  });
};
